import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-10 md:py-14 px-4 bg-[#FFFAF7] overflow-hidden" data-id="element-45">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-46">
        {/* Mobile: Images on top / Desktop: Right column */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="w-full md:w-1/2 order-1 md:order-2 relative h-[350px] sm:h-[450px] md:h-[500px] flex items-center justify-center" data-id="element-47">
          <div className="absolute z-40 -top-2 right-4 md:right-10 bg-[#FFD166] text-[#2D2D3F] font-black px-4 py-2 rounded-full shadow-lg transform rotate-6 text-sm md:text-base border-2 border-white" data-id="element-48">
            ⭐ Más elegido
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/61gUNSsSUju3Lp31K2hBty/1.png" alt="Mega Pack Disney Mockup" width="800" height="800" fetchPriority="high" decoding="async" loading="eager" className="w-full max-w-[500px] object-contain drop-shadow-2xl" data-id="element-49" />
        </motion.div>

        {/* Mobile: Text below / Desktop: Left column */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="w-full md:w-1/2 order-2 md:order-1 flex flex-col space-y-6" data-id="element-50">
          <div className="space-y-3" data-id="element-51">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#2D2D3F] leading-tight" data-id="element-52">
              El Mega Pack Disney para colorear que transforma cualquier tarde
              en un momento creativo y divertido
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-[#6B7280] font-medium" data-id="element-53">
              Más de 10 colecciones completas en formato digital para descargar,
              imprimir y colorear cuando quieras.
            </p>
          </div>

          <ul className="space-y-2" data-id="element-54">
            {['Descarga inmediata', 'Imprimí sin límites', '10 colecciones diferentes', 'Ideal para marcadores, lápices y acrílicos'].map((item, index) => <li key={index} className="flex items-center text-[#2D2D3F] font-semibold text-sm sm:text-base" data-id="element-55">
                <div className="bg-[#FFD166]/20 p-1 rounded-full mr-3 shrink-0" data-id="element-56">
                  <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-[#FFD166]" data-id="element-57" />
                </div>
                {item}
              </li>)}
          </ul>

          <div className="bg-white rounded-2xl p-5 shadow-lg border-2 border-[#FF6B8A]/20 relative mt-2" data-id="element-58">
            <div className="absolute -top-3 left-5 bg-[#FFD166] text-[#2D2D3F] text-xs font-bold px-3 py-1 rounded-full shadow-sm" data-id="element-59">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mt-2" data-id="element-60">
              <div data-id="element-61">
                <h3 className="text-lg sm:text-xl font-bold text-[#2D2D3F]" data-id="element-62">
                  Mega Pack Disney
                </h3>
                <p className="text-[#6B7280] text-sm" data-id="element-63">
                  10 colecciones completas
                </p>
              </div>
              <div className="text-left sm:text-right" data-id="element-64">
                <span className="text-gray-400 line-through text-sm sm:text-base block" data-id="element-65">
                  $59.990
                </span>
                <span className="text-2xl sm:text-3xl font-extrabold text-[#FF6B8A]" data-id="element-66">
                  🔥 $29.990 ARS
                </span>
              </div>
            </div>
          </div>

          <button onClick={scrollToPricing} className="w-full bg-[#FF6B8A] hover:bg-[#ff5275] text-white font-bold py-4 px-6 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-lg sm:text-xl" data-id="element-67">
            QUIERO EL MEGA PACK AHORA
          </button>
        </motion.div>
      </div>
    </section>;
}